import { render, staticRenderFns } from "./InputFormatadorDeValor.vue?vue&type=template&id=06c43ff6&scoped=true"
import script from "./InputFormatadorDeValor.vue?vue&type=script&lang=js"
export * from "./InputFormatadorDeValor.vue?vue&type=script&lang=js"
import style0 from "./InputFormatadorDeValor.vue?vue&type=style&index=0&id=06c43ff6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c43ff6",
  null
  
)

export default component.exports